import moment from 'moment';
import * as React from 'react';
import { DateRangePicker } from "materialui-daterange-picker";
import 'bootstrap-daterangepicker/daterangepicker.css';
import { DateFormats } from '../../utils';
import classnames from 'classnames';

interface IDateRangeListFilterProps {
    default?: IDateRange;
    placeholder?: string;
    onChange: (data?: IDateRange) => void;
}

const DateRangeListFilterWithCustomButton: React.FunctionComponent<IDateRangeListFilterProps> = (
    props
) => {
    const [range, setRange] = React.useState<IDateRange | undefined>(
        props.default
    );
    const [open, setOpen] = React.useState(false);
    // React.useEffect(() => {
    //   props.onChange(
    //     range?.startDate && range?.endDate
    //       ? { startDate: range.startDate, endDate: range.endDate }
    //       : undefined
    //   );
    // }, [range]);

    React.useEffect(() => {
        if (props.default) {
            setRange(props.default);
        }
    }, [props.default]);

    const onRangeChange = (startDate: Date, endDate: Date) => {
        setRange({
            startDate,
            endDate,
        });
        props.onChange(startDate && endDate ? { startDate, endDate } : undefined);
    };

    const hasValue = range?.startDate && range?.endDate;
    return (
        <React.Fragment>
            <div
            >
                <div className='position-relative d-flex'>
                    <input
                        type="text"
                        className={classnames({
                            'form-control border-0 px-0': true,
                            'font-weight-semibold': hasValue,
                            'font-weight-normal text-muted': !hasValue,
                        })}
                        value={`${range && hasValue
                            ? `${moment(range.startDate).format(
                                DateFormats.NormalDateFormatWithoutHiphons
                            )} - ${moment(range.endDate).format(
                                DateFormats.NormalDateFormatWithoutHiphons
                            )}`
                            : props?.placeholder ?? 'Select date range'
                            }`}
                        onClick={() => setOpen(true)}
                    />
                    {hasValue && (
                        <i
                           role='button'
                            className="icon-close font-sm mt-3"
                            onClick={() => {
                                setRange(undefined);
                                props.onChange(undefined);
                            }}
                        ></i>
                    )}
                </div>

                <div className='position-absolute' style={{ right: 0,zIndex: 9999 }} >
                    <DateRangePicker
                        wrapperClassName={open ?'daterange-picker' : ''}
                        open={open}
                        toggle={() => setOpen(prev => !prev)}
                        onChange={(dateRange) => props.onChange(dateRange)}
                    />
                </div>

            </div>
        </React.Fragment>
    );
};

export interface IDateRange {
    startDate?: Date;
    endDate?: Date;
}

export default DateRangeListFilterWithCustomButton;
